module.exports = __webpack_public_path__ + "img/stone_7b.b2ecb582.png";